import { getEmojiAliases, getEmojiIndex } from '../data'
import type { EmojiData } from '../types'

export const SUPPORTED_EMOJI_DATA_SETS: string[] = ['apple', 'google']

const hexToNumber = (u: string): number => {
  if (!/^[0-9a-f]+$/i.test(u)) {
    throw new Error(`Invalid hex string: ${u}`)
  }
  return parseInt(`0x${u}`, 16)
}

export function unifiedToNative(unified: string) {
  const unicodes = unified.split('-')
  const codePoints = unicodes.map(hexToNumber)
  return String.fromCodePoint.apply(null, codePoints)
}

export function getEmojiTitle(emojiId: string) {
  const emoji = Object.values(getEmojiIndex()).find(
    (emoji) => emoji.id === emojiId
  )
  return emoji?.name ?? emojiId.toUpperCase()
}

export function getEmojiNativeText(emoji: EmojiData) {
  return emoji.skins[0]?.native || ''
}

export function getEmojiByUnified(unified: string) {
  return Object.values(getEmojiIndex()).find((emoji) =>
    emoji.skins.some((e) => e?.unified.toUpperCase() === unified.toUpperCase())
  )
}

export function getEmojiByNative(native: string) {
  const unified = Array.from(native)
    .map((cp) => (cp.codePointAt(0) || '').toString(16))
    .join('-')
  return getEmojiByUnified(unified)
}

export function getEmojiById(id: string) {
  const aliasedId = getEmojiAliases()[id]
  return getEmojiIndex()[aliasedId ?? id]
}

export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
